module.exports = __webpack_public_path__ + "static/img/rou_lei_dan_bai.f2dbba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rou_lei_dan_bai.png
// module id = 3JND
// module chunks = 18